import slide1 from './assets/1.webp';
import slide2 from './assets/2.webp';
import slide3 from './assets/3.webp';
import slide4 from './assets/4.webp';
import slide5 from './assets/5.webp';

export const bigInfoContent = {
  slides: [
    {
      image: slide1,
      heading: {
        lines: [
          [{ text: 'энергия', accent: true }],
          [
            { text: 'воды', accent: true },
            { text: ' и жизнь', accent: false },
          ],
          [{ text: 'на берегу', accent: false }],
        ],
      },
      body: [
        {
          segments: [
            {
              text: 'первая линия Камы открывает курортные сценарии прямо у дома. встречайте рассветы на рыбалке, выходите на воду на сапбордах или плавайте в реке жарким летом.',
              accent: true,
            },
          ],
        },
        {
          segments: [
            {
              text: 'близость к большой воде работает как природный антистресс. ежедневное созерцание водной глади успокаивает мысли и замедляет ритм большого города',
              accent: false,
            },
          ],
        },
      ],
    },
    {
      image: slide2,
      heading: {
        lines: [
          [{ text: 'природная ингаляция', accent: true }],
          [{ text: 'и фитонциды', accent: false }],
        ],
      },
      body: [
        {
          segments: [
            {
              text: 'воздух в «Причале» работает как невидимый щит. Закамский бор насыщает его фитонцидами — активными веществами, которые подавляют развитие бактерий и укрепляют иммунитет.',
              accent: true,
            },
            {
              text: ' ежедневное насыщение кислородом гарантирует глубокий сон и быстрое восстановление сил',
              accent: false,
            },
          ],
        },
      ],
    },
    {
      image: slide3,
      heading: {
        lines: [
          [{ text: 'психологическое', accent: true }],
          [{ text: 'спокойствие', accent: false }],
        ],
      },
      body: [
        {
          segments: [
            {
              text: 'здесь взгляд отдыхает. отсутствие давящих высоток и бесконечного асфальта снижает уровень визуального шума.',
              accent: true,
            },
          ],
        },
        {
          segments: [
            {
              text: 'вы видите горизонт, небо и зелень — это научно доказанный фактор, снижающий уровень кортизола после напряженного рабочего дня',
              accent: false,
            },
          ],
        },
      ],
    },
    {
      image: slide4,
      heading: {
        lines: [
          [{ text: 'кислородное', accent: true }],
          [{ text: 'насыщение', accent: true }],
          [{ text: 'и глубокий сон', accent: false }],
        ],
      },
      body: [
        {
          segments: [
            {
              text: 'уникальная аэродинамика места: свежий речной бриз с Камы смешивается с насыщенным кислородом лесным воздухом.',
              accent: true,
            },
          ],
        },
        {
          segments: [
            {
              text: 'такая концентрация кислорода гарантирует быстрое восстановление сил и качественный, глубокий сон, которого так не хватает в центре мегаполиса',
              accent: false,
            },
          ],
        },
      ],
    },
    {
      image: slide5,
      heading: {
        lines: [
          [{ text: 'жизнь', accent: true, caps: false }],
          [
            { text: 'в ', accent: false },
            { text: 'ритме', accent: false },
          ],
        ],
      },
      body: [
        {
          segments: [
            {
              text: 'локация сама диктует размеренный темп. здесь нет городской суеты и трафика под окнами.',
              accent: true,
            },
          ],
        },
        {
          segments: [
            {
              text: 'это пространство для осознанного замедления: утренней йоги на набережной, неспешных прогулок по лесу и тихих вечеров, когда слышен только шелест листвы',
              accent: false,
            },
          ],
        },
      ],
    },
  ],
};
